import _defaultTo from 'lodash/defaultTo';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import _orderBy from 'lodash/orderBy';
// Serialization
import { deserialize, serialize } from 'serializr';
import { entitySchema } from './schemas';
// Models
import mProduct from './product';
// Permissions
import permissions from '../constants/Permissions';

/**
* Serialization
*/
const serializerKey = 'entity';

const deserializeEntity = (data) => deserialize(entitySchema, data);

const serializeEntity = ({
  name, publicName, product, capacity, companyId, isOnDemand, excludedDoors, allowListingOneparkBookings,
}) => ({
  [serializerKey]: {
    ...serialize(entitySchema, {
      ...(!_isNil(allowListingOneparkBookings) && { allow_listing_of_onepark_bookings: allowListingOneparkBookings }),
      ...(name && { name }),
      ...(publicName && { public_name: publicName }),
      ...(product && { product }),
      ...(!_isNil(capacity) && { capacity }),
      company_id: _defaultTo(companyId, null),
      ...(!_isNil(isOnDemand) && { is_on_demand: isOnDemand }),
      ...(excludedDoors && { excluded_doors: excludedDoors }),
    }),
  },
});

/**
* Utils
*/
const sortEntities = (entities, fields = ['name'], dirs = ['asc']) => (_orderBy(entities, fields, dirs));

const entityIsMaster = (entityData) => _get(entityData, 'type') === 'master';
const entityHostsOneparkBookings = (entityData) => _get(entityData, 'type') === 'hosts_onepark_bookings';
const entityIsCpm = (entityData) => _get(entityData, 'product') === mProduct.getConfigurationCpmValue;
const entityAttributes = (entityData) => ({
  isMaster: entityIsMaster(entityData),
  hostsOneparkBookings: entityHostsOneparkBookings(entityData),
  isCpm: entityIsCpm(entityData),
  name: _get(entityData, 'name'),
});

/**
* Model
*/
const entity = {
  // Name
  name: 'entity',
  icon: 'entity',

  // Serialization
  deserialize: deserializeEntity,
  serialize: serializeEntity,

  // Sort elements
  sortElements: sortEntities,
  isMaster: entityIsMaster,
  hostsOneparkBookings: entityHostsOneparkBookings,
  isCpm: entityIsCpm,
  attributes: entityAttributes,

  // List features
  listFeatures: {
    // Default list param (not used)
    defaultParams: {
      pagination: {
        page: 1,
        pageSize: 20,
      },
      sort: [],
    },

    // Columns
    columnsQuantity: (hasPermission) => ({
      xs: 2,
      sm: 2,
      md: 3,
      lg: 3 + (hasPermission({ needed: permissions.pAdmin }) | 0),
      xl: 3 + (hasPermission({ needed: permissions.pAdmin }) | 0),
    }),
    columns: [
      {
        key: 'name',
        labelId: 'field.name',
        field: 'name',
        sortable: false,
      },
      {
        key: 'company',
        labelId: 'field.company',
        field: 'company',
        permissions: {
          needed: permissions.pAdmin,
        },
        sortable: false,
        className: 'hidden-md-down',
      },
      {
        key: 'capacity',
        labelId: 'field.capacity',
        field: 'capacity',
        sortable: false,
        className: 'table-content-1 hidden-sm-down',
      },
      {
        key: 'status',
        labelId: 'field.status',
        field: 'status',
        sortable: false,
        className: 'table-content-1 table-content-center',
      },
    ],

    // Search fields
    searchFields: [],
  },
};

module.exports = entity;



// WEBPACK FOOTER //
// ./models/entity.js